import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Row, Col, Tree, Button, Spin } from 'antd';
import BaseContent from 'components/BaseContent';
import Ficon from 'components/Ficon';
import {getAppkey} from 'actions/appkey';
import {searchPermissionTree, PERMISSION_ORIGIN_TREE, expandPermissionObject} from './const';
import Clipboard from 'clipboard';
import style from './index.less';

const TreeNode = Tree.TreeNode;
const APPKEY_TYPE = ['Formal', 'Test'];
class AppkeyView extends React.Component {
    state = {
        viewSecrect: false,
        appkey: {},
        spinning: true
    };

    onSecretVisibleChange = ()=> {
        this.setState({viewSecrect: !this.state.viewSecrect});
    }
    componentDidMount() {
        this.appClipboard = new Clipboard(
            this.copyLink,
            {
                target: () => this.appkeyField
            }
        );
        this.secretClipboard = new Clipboard(
            this.copySecretLink,
            {
                target: () => this.appsecretField
            }
        );

        getAppkey(this.props.match.params.id).then(res=> {
            this.setState({spinning: false, appkey: res.data});
        }).catch(()=> {
            this.setState({spinning: false});
        });
    }

    renderPermTree = (treeData)=> {
        const treeNodes = [];
        treeData.forEach(item=> {
            if (item.children) {
                treeNodes.push(<TreeNode title={item.label} key={item.key}>{this.renderPermTree(item.children)}</TreeNode>);
            }else {
                treeNodes.push(<TreeNode title={item.label} key={item.key} />);
            }
        });
        return treeNodes;
    }

    render() {
        const { appkey } = this.state;
        const permissions = expandPermissionObject(appkey.permissions);
        const treeData = searchPermissionTree(permissions, PERMISSION_ORIGIN_TREE);
        const treeNodes = this.renderPermTree(treeData);
        const footer = (
            <Row>
                <Col style={{marginLeft:60}}>
                    <Button type="primary" style={{width: 120}} onClick={()=> this.props.history.push('/pages/app/appkey')}>Back</Button>
                </Col>
            </Row>
        );
        let appKeyLimitString;
        if (appkey.type === 1 ) {
            appKeyLimitString = appkey.times_limit <= -1 ? '（Upper limit: no limit）' :  `（Upper limit: ${appkey.times_limit}; Used times: ${appkey.times_used}）`;
        }
        const colStyle = {textAlign: 'right',width:120,float:'left'};
        return (
            <BaseContent style={{minHeight: 0}} footer={footer}>
                <Spin spinning={this.state.spinning}>
                    <Card title="AppKey Check" bordered={false} style={{color:'#515666'}}>
                        <Row style={{marginBottom: 20}}>
                            <Col style={colStyle}>AppKey：</Col>
                            <strong ref={ref=> this.appkeyField = ref}>{appkey.api_key}</strong>
                            <a  ref={ref=> this.copyLink = ref}>
                                <Ficon type="copy" style={{margin: '0 5px 0 10px'}}/>
                                <span>Copy</span>
                            </a>
                        </Row>
                        <Row style={{marginBottom: 20}}>
                            <Col style={colStyle}>AppSecret：</Col>
                            <strong ref={ref=> this.appsecretField = ref}>{this.state.viewSecrect ? appkey.api_secret : '******'}</strong>
                            <a onClick={this.onSecretVisibleChange} >
                                <Ficon type={this.state.viewSecrect ? 'eye-close' : 'eye-open'} style={{margin: '0 5px 0 10px'}}/>
                                <span>{this.state.viewSecrect ? 'Hide' : 'Visible'}</span>
                            </a>
                            <a  ref={ref=> this.copySecretLink = ref}
                                style={{display: this.state.viewSecrect ? '':'none'}}>
                                <Ficon type="copy" style={{margin: '0 5px 0 10px'}}/>
                                <span>Copy</span>
                            </a>
                        </Row>
                        <Row style={{marginBottom: 20}}>
                            <Col style={colStyle}>Appkey type：</Col>
                            <strong> {APPKEY_TYPE[appkey.type]} {appKeyLimitString} </strong>
                        </Row>

                        <Row style={{marginBottom: 20}}>
                            <Col style={colStyle}>Appkey QPS：</Col>
                            <strong> {appkey.concurrency} </strong>
                        </Row>
                        <Row style={{marginBottom: 20}}>
                            <Col style={colStyle}>API permissions：</Col>
                            <Col span={12}>
                                {treeNodes.length === 0 ? 'No permissions' :
                                    <Tree
                                        showLine
                                        defaultExpandAll={true}
                                        onSelect={this.onSelect}
                                        className={style.tree}
                                    >
                                        {treeNodes}
                                    </Tree>
                                }

                            </Col>
                        </Row>

                    </Card>
                </Spin>
            </BaseContent>
        );
    }
}

export default withRouter(AppkeyView);



// WEBPACK FOOTER //
// ./src/pages/Appkey/view.js